import {ReactNode} from 'react';

import {IconName} from '../../../../libs/shared/ui/src/components/icon/icon';
import {AdminOnboardingTaskDefinition} from '../admin/tasks/adminOnboardingTypes';

/*
 * Types.
 */

export enum AdminSetupGuideScreensEnum {
  DEFAULT = 'default', // Have the setup guide compute the appropriate screen.
  DEMOS = 'demos',
  SETUP = 'setup',
  MORE = 'more',
}

// Everything but "default" (which dynamically computes the appropriate screen).
export type AdminSetupGuideConcreteScreen =
  | AdminSetupGuideScreensEnum.DEMOS
  | AdminSetupGuideScreensEnum.SETUP
  | AdminSetupGuideScreensEnum.MORE;

export interface AdminSetupGuideResourceTaskResource {
  key: string;
  title: ReactNode;
  displayName: string;
  icon: IconName;
  link: string;
  isInternal?: boolean;
}

export interface AdminSetupGuideResourceTaskDefinition {
  key: string;
  title: ReactNode;
  image: string;
  resources: ReadonlyArray<AdminSetupGuideResourceTaskResource>;
}

export interface AdminSetupGuideScreenTask {
  key: React.Key;
  number: number;
  title: ReactNode;
  description: ReactNode;
  isComplete: boolean | undefined;
  isExternal: boolean;
  details: ReactNode;
  startTask: AdminOnboardingTaskDefinition['startTask'];
}

export interface AdminSetupGuideScreenTasksAndProgress {
  tasks: ReadonlyArray<AdminSetupGuideScreenTask>;
  progress: {
    totalSteps: number;
    completedSteps: number;
    hasCompletedAllTasks: boolean;
  };
}

export interface AdminSetupGuideTasksAndProgress {
  demos: AdminSetupGuideScreenTasksAndProgress;
  setup: AdminSetupGuideScreenTasksAndProgress;
}

export interface AdminSetupGuideTaskDefinitions {
  demos: ReadonlyArray<AdminOnboardingTaskDefinition>;
  setup: ReadonlyArray<AdminOnboardingTaskDefinition>;
}
